import { motion } from 'framer-motion';

import {
  imgStyle,
  inlineContainerStyle,
  likeButtonStyle,
  nameStyle,
  textStyle
} from '@/components/Likes/LikeCard/styles.ts';
import { MAX_NAME_LENGTH } from '@/components/Likes/LikesList.tsx';
import { CandidateProfilePhotosDto } from '@/api/matchmaker/types.ts';
import { helpers } from '@/helpers.ts';
import { ImageWithLoader } from '@/components/common/Image/ImageWithLoader.tsx';
import HeartSimpleShape from '@/components/common/svg/shapes/HeartSimpleShape.tsx';
import VerifiedBadgeShape from '@/components/common/svg/shapes/VerifiedBadgeShape.tsx';

const LikeCard = ({
  imgUrl,
  name,
  age,
  onClick,
  onLike,
  isBlured
}: {
  imgUrl?: CandidateProfilePhotosDto;
  name: string;
  age: number;
  onClick: () => void;
  onLike: () => void;
  isBlured?: boolean;
}) => {
  const truncatedName =
    name.length > MAX_NAME_LENGTH
      ? name.slice(0, MAX_NAME_LENGTH) + '...'
      : name;

  return (
    <>
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '220px',
          clipPath: 'inset(0 round 35px)'
        }}
        onClick={onClick}
      >
        <ImageWithLoader
          key={helpers.getPrimaryPhoto(imgUrl?.variants ?? [])}
          src={helpers.getPrimaryPhoto(imgUrl?.variants ?? []) ?? ''}
          thumbhash={helpers.getThumbHash(imgUrl?.variants ?? [])}
          alt=""
          fallbackIconHeight={65}
          fallbackIconWidth={50}
          style={{
            ...imgStyle,
            ...(isBlured ? { filter: 'blur(10px)' } : {})
          }}
        />
      </div>
      {!isBlured && (
        <div style={nameStyle} onClick={onClick}>
          <div style={inlineContainerStyle}>
            <span style={textStyle}>
              {truncatedName}
              {age !== 0 ? `, ${age}` : ''}
            </span>
            <VerifiedBadgeShape
              width={18}
              height={18}
              style={{ marginLeft: 3 }}
            />
          </div>
        </div>
      )}
      <motion.div
        style={likeButtonStyle}
        onClick={onLike}
        whileTap={{
          scale: 0.8,
          transition: { type: 'spring', stiffness: 300, damping: 10 }
        }}
      >
        <HeartSimpleShape width={22} height={22} fillColor="#ffffff" />
      </motion.div>
    </>
  );
};

export default LikeCard;